module.exports = __webpack_public_path__ + "autosaw.webp?f8066c090f670ee01fb1cdc456a7f13d";